var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6781 12.2605L42.356 16.2402C41.9153 16.6459 41.2028 16.6459 40.7622 16.2402L30.3554 6.65794C29.9148 6.2522 29.9148 5.59612 30.3554 5.19038L34.6775 1.21073C36.4307 -0.403577 39.2808 -0.403577 41.0434 1.21073L46.6781 6.39896C48.4406 8.01326 48.4406 10.6376 46.6781 12.2605ZM26.6428 8.60892L2.02287 31.2783L0.0352802 41.7669C-0.236607 43.1827 1.10408 44.4085 2.64165 44.1668L14.0328 42.3281L38.6527 19.6587C39.0933 19.253 39.0933 18.5969 38.6527 18.1912L28.246 8.60892C27.7959 8.20318 27.0834 8.20318 26.6428 8.60892ZM11.6327 29.3359C11.117 28.8611 11.117 28.1014 11.6327 27.6267L26.0709 14.3324C26.5865 13.8576 27.4115 13.8576 27.9272 14.3324C28.4428 14.8072 28.4428 15.5668 27.9272 16.0416L13.489 29.3359C12.9734 29.8107 12.1483 29.8107 11.6327 29.3359ZM8.24816 36.596H12.7484V39.7296L6.70121 40.7051L3.78545 38.0204L4.84488 32.4523H8.24816V36.596Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1a51328135af7082d1af2160ab95f709.svg";
export { ForwardRef as ReactComponent };